RivalIQ.apps.Registration.module('views', function (views, App, Backbone, Marionette, $, _) {
    'use strict';

    const TOTAL_DURATION = 7000;
    const NUM_STEPS = 60;
    const STEP_DURATION = TOTAL_DURATION / NUM_STEPS;

    views.PostSignupPage = Marionette.ItemView.extend({
        template: '#registrationPostSignupTemplate',

        ui: {
            progressBar: '.progress-bar',
            registrationCompleteBtn: '.registration-complete-btn',
            pageOneText: '.desc-page-one',
            pageTwoText: '.desc-page-two'
        },

        events: {
            'click @ui.registrationCompleteBtn': 'onCompleteClicked'
        },

        poll: function () {
            const me = this;

            const pctComplete = (++me.step / NUM_STEPS);
            me.isComplete = (pctComplete >= 1);

            if (me.isRendered) {
                const width = (me.isComplete ? 100 : pctComplete * 100);
                me.ui.progressBar.css('width', `${width}%`);
            }

            if (me.isComplete) {
                me.onProgressComplete();
            } else {
                me.pollTimeout = setTimeout(_.bind(me.poll, me), STEP_DURATION);
            }
        },

        onProgressComplete: function () {
            const me = this;

            me.ui.progressBar.removeClass('in-progress');
            me.ui.registrationCompleteBtn.removeClass('disabled');
            me.ui.registrationCompleteBtn.text('Start using Rival IQ');

            me.ui.pageOneText.velocity('fadeOut', {
                duration: 150,
                complete: function () {
                    me.ui.pageTwoText.velocity('fadeIn', {
                        duration: 700
                    });
                }
            });
        },

        onCompleteClicked: function () {
            RivalIQ.execute('tracking:push:auth', 'V3RegistrationEnteredApp');
            window.location = RivalIQ.state.product.get('defaultRedirectLocation');
        },

        onDestroy: function () {
            const me = this;
            clearTimeout(me.pollTimeout);
        },

        onShow: function () {
            const me = this;

            me.step = 0;
            me.pollTimeout = setTimeout(_.bind(me.poll, me), STEP_DURATION);
        },

        templateHelpers: function () {
            const me = this;

            return {
                isShare: Boolean(me.options.isShare)
            };
        }
    });

});
